import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26ab731e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination m-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationLinkComponent = _resolveComponent("PaginationLinkComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.data.previousPage)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: {
        name: 'mods',
        params: {
            game: this.$route.params.game
        },
        query: {
            category: this.$route.query.category,
            page: _ctx.data.previousPage
        }
    }
        }, {
          default: _withCtx(() => [
            _createTextVNode("«")
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_PaginationLinkComponent, {
      pageLink: 1,
      to: {
                                name: 'mods',
                                params: {
                                    game: this.$route.params.game
                                },
                                query: {
                                    category: this.$route.query.category,
                                    page: 1
                                }
                            }
    }, null, 8, ["to"]), [
      [_vShow, _ctx.checkPrevPage]
    ]),
    _withDirectives(_createElementVNode("a", null, "...", 512), [
      [_vShow, _ctx.checkPrevPage]
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.items, (row) => {
      return (_openBlock(), _createBlock(_component_PaginationLinkComponent, {
        pageLink: row,
        to: {
                                name: 'mods',
                                params: {
                                    game: this.$route.params.game
                                },
                                query: {
                                    category: this.$route.query.category,
                                    page: row
                                }
                            }
      }, null, 8, ["pageLink", "to"]))
    }), 256)),
    _withDirectives(_createElementVNode("a", null, "...", 512), [
      [_vShow, _ctx.checkNextPage]
    ]),
    _withDirectives(_createVNode(_component_PaginationLinkComponent, {
      pageLink: _ctx.data.lastPage,
      to: {
                                name: 'mods',
                                params: {
                                    game: this.$route.params.game
                                },
                                query: {
                                    category: this.$route.query.category,
                                    page: _ctx.data.lastPage
                                }
                            }
    }, null, 8, ["pageLink", "to"]), [
      [_vShow, _ctx.checkNextPage]
    ]),
    (_ctx.data.nextPage)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: {
          name: 'mods',
          params: {
              game: this.$route.params.game
          },
          query: {
              category: this.$route.query.category,
              page: _ctx.data.nextPage
          }
      }
        }, {
          default: _withCtx(() => [
            _createTextVNode("»")
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true)
  ]))
}